import { useState } from "react";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

const NAV_LINKS = [
    { label: "Servicios", href: "#servicios", id: "nav-services" },
    { label: "Proceso", href: "#proceso", id: "nav-process" },
    { label: "Industrias", href: "#industrias", id: "nav-industries" },
    { label: "Contacto", href: "#contacto", id: "nav-contact" },
];

const formatTime = (d) => {
    return d.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });
};

const Header = ({ time }) => {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 w-full backdrop-blur-2xl bg-black/60 border-b border-white/10"
        >
            <div className="flex items-center justify-between px-6 md:px-12 lg:px-16 py-4">
                <a
                    href="#top"
                    data-testid="logo-link"
                    className="flex items-center gap-3 group"
                >
                    <span className="block w-2.5 h-2.5 bg-[#1A9EC9] group-hover:bg-white transition-colors" />
                    <span className="font-display text-2xl tracking-tighter uppercase">
                        Terah
                    </span>
                    <span className="hidden md:inline text-[10px] tracking-[0.3em] text-white/40 font-mono uppercase border-l border-white/10 pl-3 ml-1">
                        Infraestructura · Seguridad · Energía
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={l.href}
                            data-testid={l.id}
                            className="text-xs tracking-[0.25em] uppercase text-white/60 hover:text-white transition-colors font-mono"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-4">
                    <span
                        data-testid="header-clock"
                        className="hidden md:inline text-[10px] tracking-[0.25em] uppercase text-white/40 font-mono"
                    >
                        UTC · {formatTime(time)}
                    </span>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="header-cta-button"
                        className="hidden md:inline-flex items-center gap-2 bg-[#1A9EC9] hover:bg-white hover:text-black text-white px-5 py-2.5 text-xs tracking-[0.2em] font-bold uppercase font-mono transition-colors"
                    >
                        Cotizar →
                    </a>
                    <button
                        type="button"
                        onClick={() => setOpen(!open)}
                        data-testid="mobile-menu-toggle"
                        className="lg:hidden text-white p-2 -mr-2"
                        aria-label="Abrir menú"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="lg:hidden border-t border-white/10 bg-black"
                >
                    <div className="flex flex-col divide-y divide-white/10">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.id}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-${l.id}`}
                                className="px-6 py-5 text-sm tracking-[0.2em] uppercase font-mono hover:bg-white/5"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="mobile-cta"
                            className="px-6 py-5 text-sm tracking-[0.2em] uppercase font-bold font-mono bg-[#1A9EC9] text-white"
                        >
                            Cotizar Ahora →
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
